import React, { FC } from "react";
import { Image } from "cloudinary-react";

export const About: FC<{}> = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 d-none d-md-block">
            <div className="assets">
              <Image publicId="Group_88_bb7pek_f1mhnj" />
            </div>
          </div>
          <div className="col-12 col-md-6 mb-3">
            <div className="heading">
              <h2>
                Everything About <span>Us.</span>
              </h2>
            </div>
            <p>
              Speednance provides the easiest and convenient way to sell or buy
              bitcoin and usdt within minutes any where in Ghana and Nigeria. We
              provide the best rates for our customers. Our team is dedicated to
              provide maximum security and fast transactions in a click, with
              best user experience for our clients.
            </p>
            <p className="mt-4">
              24/7 live support to solve any issues regarding transactions.
              Enjoy the freedom of digital currency with Speednance. Our goal is
              to make digital currencies accessible in the African Regions.That
              is why we have started off by the best,fastest and affordable
              services in the market. Email support on info@speednance.com or
              support@speednance.com
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
